import { IdentitySearchSchema } from '@/features/dashboard/client/identity/identitySchema';
import { IdentityList } from '@/features/dashboard/client/identity/list/IdentityList'
import { usePageTitle } from '@/hooks/usePageTitle';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/identities/')({
  component: RouteComponent,
  validateSearch: (search) => {
    // IdentitySearchSchemaのデフォルト値が自動的に適用される
    return IdentitySearchSchema.parse(search);
  }
})

function RouteComponent() {
  usePageTitle("本人確認一覧");
  return <IdentityList />
}

